// extracted by mini-css-extract-plugin
export default {"backdrop":"_-_-record-it-components-src-misc-LoadingOverlay-__backdrop","spinnerWrapper":"_-_-record-it-components-src-misc-LoadingOverlay-__spinnerWrapper"};